import * as React from 'react';

import * as styles from './DailyrentActionsLayout.css';

interface IDailyrentActionsLayoutProps {
  children: React.ReactNode;
}

export const DailyrentActionsLayout: React.FC<IDailyrentActionsLayoutProps> = ({ children }) => {
  return (
    <div className={styles['root']} data-name="DailyrentActionButtonsContainer">
      {children}
    </div>
  );
};
